import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { InboxContext } from '../types';
import { setOutboundCallToCompleted } from '../callHandlers/outboundCalls';

import {
  setCallToCompleted,
  setCallToWrapup,
} from '../callHandlers/callStateHandler';
import { TaskState } from '@modules/TasksModule/types';
import InboxModule from '..';

function handleCallEnded(context: InboxContext, event: CallEvent) {
  const taskId = event.pcsConversationSid || event.callId;

  const task =
    TasksModule.getTask(taskId) ?? TasksModule.getTaskByCallId(event.callId);

  // we should only transition tasks that are in accepted state
  if (!task) {
    return;
  }

  if (TasksModule.getTask(task.id)) {
    TasksModule.setTaskAttribute(task.id, 'callEndedTime', Date.now());
  }

  // we only want to transition tasks that are in accepted state
  if (task.state !== TaskState.Accepted) {
    return;
  }

  if (InboxModule.shouldRetainEndedCallCard(task)) {
    // keep the card (and any booking on it) until the CSR closes it
    setCallToWrapup(context, task.id);
  } else if (task.isOutbound) {
    // if this is an outbound then we should mark the task as completed
    setOutboundCallToCompleted(context, task.id);
  } else if (task.attributes.shouldClassify) {
    setCallToWrapup(context, taskId);
  } else if (!task.attributes.shouldClassify) {
    setCallToCompleted(context, taskId, false);
  }
}

export default handleCallEnded;
